import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import queryString from "query-string";
import Loader from "../../../assets/icons/loader/loader";
import DeleteModal from "../../../components/modal/delete-modal";
import AdminFilterDrawer from "../../../components/filter/admin-filter-drawer";
import CustomerDeliveryAddressCreateModal from "./customer-delivery-address-create-modal";
import CustomerDeliveryAddressViewModal from "./customer-delivery-address-view-modal";
import CustomerDeliveryAddressEditModal from "./customer-delivery-address-edit-modal";
import { api } from "../../../redux/apis/api";
import { useRole } from "../../../context/role/RoleContext";

const CustomerDeliveryListList = ({ activeTab }) => {
  const location = useLocation();
  const { state } = useRole();
  const params = useParams();
  const permission = state?.role?.customer;
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);

  const [data, setData] = useState({
    rows: [],
    page: 1,
    count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [ViewDeleteModalShow, setViewDeleteModalShow] = useState(false);
  const [selectDelete, setSelectDelete] = useState("");
  const [leadsCreate, setLeadsCreate] = useState(false);
  const [leadsEdit, setLeadsEdit] = useState(false);
  const [leadsView, setLeadsView] = useState(false);
  const [selectID, setSelectID] = useState("");
  const [stateList, setstateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);

  const fetchData = () => {
    const rawFilters = queryString.parse(location.search, {
      arrayFormat: "bracket",
    });

    const filters = normalizeParsedParams(rawFilters);

    setLoading(true);
    api
      .post(`/customer/delivery-address/list`, {
        page: page_no,
        customer_id: params?.id,
        ...filters,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  function normalizeParsedParams(parsed) {
    const result = {};

    for (const [key, value] of Object.entries(parsed)) {
      const match = key.match(/^(\w+)\[(\w+)\]$/);
      if (match) {
        const [, parent, child] = match;
        if (!result[parent]) result[parent] = {};
        result[parent][child] = value;
      } else {
        result[key] = value;
      }
    }

    return result;
  }

  useEffect(() => {
    fetchData();
  }, [page_no, location.search]);

  const deleteFnc = (id) => {
    api
      .post(`/customer/delivery-address/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const ViewDeleteFnc = (id) => {
    api
      .post(`/customer/delivery-address/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const fetchStateDropDownData = () => {
    api
      .post(`/settings/state-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.states?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setstateList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchCityDropDownData = () => {
    api
      .post(`/settings/city-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.cities?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCitiesList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchStateDropDownData();
    fetchCityDropDownData();
  }, []);

  const filterInputs = [
    {
      label: "Name",
      type: "text",
      name: "name",
    },
    {
      label: "state",
      type: "dropdown",
      name: "state_id",
      options: stateList,
    },
    {
      label: "city",
      type: "dropdown",
      name: "city_id",
      options: citiesList,
    },
    {
      label: "created At",
      type: "date",
      name: "createdAt",
    },
    {
      label: "updated At",
      type: "date",
      name: "updatedAt",
    },
  ];

  return (
    <section>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
          setSelectDelete("");
        }}
        btnFnc={() => deleteFnc(selectDelete)}
      />
      {/* ------------- FOR VIEW ------------- */}
      <DeleteModal
        isOpen={ViewDeleteModalShow}
        onClose={() => {
          setViewDeleteModalShow(false);
          setSelectDelete("");
        }}
        viewDeleteFnc={() => {
          setLeadsView(true);
          setSelectID(selectID);
        }}
        btnFnc={() => ViewDeleteFnc(selectID)}
      />
      <CustomerDeliveryAddressCreateModal
        isOpen={leadsCreate}
        onClose={() => {
          setLeadsCreate(false);
        }}
        listFnc={fetchData}
        customer_id={params?.id}
      />
      <CustomerDeliveryAddressEditModal
        selectID={selectID}
        isOpen={leadsEdit}
        onClose={() => {
          setLeadsEdit(false);
        }}
        customer_id={params?.id}
        listFnc={fetchData}
      />
      <CustomerDeliveryAddressViewModal
        selectID={selectID}
        isOpen={leadsView}
        onClose={() => {
          setLeadsView(false);
        }}
        deleteDisable={permission?.write}
        listFnc={fetchData}
        onDeleteFnc={() => {
          setViewDeleteModalShow(true);
          setLeadsView(false);
        }}
      />
      <div className="flex justify-between items-center mb-5">
        <h2 className="text-xl font-semibold capitalize">
          customer delivery address List
        </h2>
        <div className="flex gap-2 relative">
          <AdminFilterDrawer
            open={filterDrawerOpen}
            onClose={() => setFilterDrawerOpen(false)}
            queryParamsData={queryParamsData}
            activeTab={activeTab}
            filterInputs={filterInputs}
          />
          {permission?.write && (
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded"
              onClick={() => setLeadsCreate(true)}
            >
              Create
            </button>
          )}
          <button
            onClick={() => setFilterDrawerOpen(true)}
            className="px-4 py-1 bg-secondary text-white rounded"
          >
            Filters
          </button>
        </div>
      </div>
      <div className="relative overflow-x-auto">
        <table className="w-full text-left rtl:text-right border border-gray-200">
          <thead className="text-gray-700 uppercase">
            <tr>
              <th
                scope="col"
                className="px-4 py-3 capitalize text-fs_16 font-fw_600"
              >
                id
              </th>
              <th
                scope="col"
                className="px-4 py-3 capitalize text-fs_16 font-fw_600"
              >
                name
              </th>
              <th
                scope="col"
                className="px-4 py-3 capitalize text-fs_16 font-fw_600"
              >
                address
              </th>
              <th
                scope="col"
                className="px-4 py-3 capitalize text-fs_16 font-fw_600"
              >
                state
              </th>
              <th
                scope="col"
                className="px-4 py-3 capitalize text-fs_16 font-fw_600"
              >
                city
              </th>
              <th
                scope="col"
                className="px-4 py-3 capitalize text-fs_16 font-fw_600"
              >
                pincode
              </th>
              <th
                scope="col"
                className="px-4 py-3 capitalize text-fs_16 font-fw_600"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td rowSpan={1}>
                  <div className="w-full flex justify-center py-5">
                    <div className="h-[100px] w-[100px]">
                      <Loader />
                    </div>
                  </div>
                </td>
              </tr>
            ) : (
              <>
                {data.rows?.length ? (
                  <>
                    {data.rows.map((row, index) => {
                      return (
                        <tr key={index} className="border-t bg-white">
                          <td className="p-1 px-2">{row?.id ?? "--"}</td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {row?.name ?? "--"}
                            </span>
                          </td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {row?.address ?? "--"}
                            </span>
                          </td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {row?.state?.name ?? "--"}
                            </span>
                          </td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {row?.city?.name ?? "--"}
                            </span>
                          </td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {row?.pincode ?? "--"}
                            </span>
                          </td>
                          <td className="py-2 sticky right-0 z-10">
                            <div className="flex gap-3 bg-white px-4">
                              <button
                                onClick={() => {
                                  setLeadsView(true);
                                  setSelectID(row["id"]);
                                }}
                                className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                              >
                                View
                              </button>
                              {permission?.write && (
                                <button
                                  onClick={() => {
                                    setLeadsEdit(true);
                                    setSelectID(row["id"]);
                                  }}
                                  className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                >
                                  Edit
                                </button>
                              )}
                              {permission?.write && (
                                <button
                                  onClick={() => {
                                    setdeleteModalShow(true);
                                    setSelectDelete(row["id"]);
                                  }}
                                  className="text-errorColor border-[1px] border-errorColor px-3 py-1 rounded-md text-fs_14 hover:bg-red-50"
                                >
                                  Delete
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td>
                      <p className="text-center my-5">No data found</p>
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default CustomerDeliveryListList;
